import React from 'react';

import { MigrationStepSelectTime } from '../../../common/migration/MigrationStepSelectTime';

const i18n = {
    downtimeWindow: 'CLIENT_ORGANIZATION_MIGRATION_DOWNTIME_WINDOW',
    dateWindow: 'CLIENT_ORGANIZATION_MIGRATION_DATE_WINDOW',
    whatsNext: 'CLIENT_ORGANIZATION_MIGRATION_WHATS_NEXT',
    timeInfoKeys: [
        'CLIENT_ORGANIZATION_MIGRATION_TIME_INFO_1',
        'CLIENT_ORGANIZATION_MIGRATION_TIME_INFO_2',
        'CLIENT_ORGANIZATION_MIGRATION_TIME_INFO_3',
        'CLIENT_MIGRATION_EMAIL_NOTIFICATION_INFO',
        'CLIENT_MIGRATION_DATE_COMPATIBILITY_INFO',
    ],
} as const;

export const OrgMigrationStepSelectTime: React.FC = () => (
    <MigrationStepSelectTime i18n={i18n} />
);
